// Compact warning pill used inline in the Hero CTA group.
// Permanent Authenticity rule: must remain sharp + legible but visually
// tight enough to never compete with the primary CTA.
import { AlertTriangle } from "lucide-react";

export const ELSS_SCOPE_DISCLAIMER =
    "FSRS prepares fire sprinkler retrofit layouts only. We don't design engineered life safety systems (ELSS), smoke control, or egress and exit routes. Your licensed pro makes the final design call.";

export default function MiniDisclaimer({
    className = "",
    testId = "mini-disclaimer",
    variant = "pill", // "pill" (default, tight) | "bar" (full-width thin bar)
}) {
    if (variant === "bar") {
        return (
            <div
                className={`inline-flex w-full max-w-full min-w-0 items-start gap-2 px-3 py-1.5 border-l-2 fsrs-caution fsrs-caution-fill ${className}`}
                data-testid={testId}
                role="note"
            >
                <AlertTriangle
                    className="w-3 h-3 shrink-0 mt-0.5"
                    strokeWidth={2.25}
                />
                <div className="min-w-0">
                    <p className="fsrs-mono text-[10.5px] leading-snug tracking-wide whitespace-nowrap">
                        <span className="font-semibold">
                            INTENDED USE:
                        </span>{" "}
                        preliminary analysis · PE review required
                    </p>
                    <p className="fsrs-mono text-[10.5px] leading-snug tracking-wide whitespace-normal">
                        {ELSS_SCOPE_DISCLAIMER}
                    </p>
                </div>
            </div>
        );
    }
    return (
        <span
            className={`inline-flex w-full max-w-full min-w-0 items-start gap-1.5 px-2.5 py-1 rounded-none border fsrs-caution fsrs-caution-fill text-lg font-mono tracking-wide ${className}`}
            data-testid={testId}
            role="note"
        >
            <AlertTriangle
                className="w-3 h-3 shrink-0 mt-1.5"
                strokeWidth={2.25}
            />
            <span className="min-w-0">
                <span className="block">
                    <span className="font-semibold">INTENDED USE:</span>{" "}
                    <span className="hidden sm:inline">
                        preliminary analysis · PE review required
                    </span>
                    <span className="sm:hidden">PE review req.</span>
                </span>
                <span className="block whitespace-normal leading-snug">
                    {ELSS_SCOPE_DISCLAIMER}
                </span>
            </span>
        </span>
    );
}
